import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import { ADDON_HEADERS, ADDON_LABELS, ADDON_PLACEHOLDERS } from "../constants";

const getCopyForGatheringAddonEditModal = ({
	variant,
}: {
	variant: AddonVariant;
}): { header: string; label: string; placeholder: string } => {
	return {
		header: ADDON_HEADERS[variant] ?? "Addon",
		label: ADDON_LABELS[variant] ?? "LINK",
		placeholder: ADDON_PLACEHOLDERS[variant] ?? "Add RSVP page, groupchats, and more",
	};
};
export default getCopyForGatheringAddonEditModal;
